import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.07996 3.01688L6.25658 3.58437C5.25048 4.27779 4.37742 5.15081 3.68397 6.15688L3.11645 6.98024L1.46973 5.8452L2.03725 5.02184C2.86875 3.81549 3.91522 2.76906 5.1216 1.9376L5.94498 1.37012L7.07996 3.01688Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.2448 4.46556C10.7819 3.92867 11.6529 3.92995 12.1885 4.4684L17.4423 9.75065L16.9979 8.65493C16.4384 7.27525 18.0035 6.00498 19.2385 6.83649C19.4269 6.96332 19.5842 7.13103 19.6987 7.32712L22.0783 11.4019C23.7259 14.2233 23.2639 17.8009 20.9536 20.1111L20.1093 20.9554C17.3017 23.7631 12.7495 23.7631 9.94188 20.9554L4.90742 15.9198C4.37073 15.383 4.37056 14.5128 4.90705 13.9758C5.44395 13.4384 6.31495 13.4382 6.85213 13.9753L8.45572 15.5789L8.98679 15.0478L5.29669 11.3577C4.75982 10.8209 4.75981 9.95045 5.29666 9.41357C5.83353 8.87668 6.70399 8.87667 7.24088 9.41355L10.931 13.1037L11.4613 12.5733L6.40446 7.51647C5.86764 6.97965 5.86747 6.10934 6.40408 5.57231C6.94099 5.03498 7.81188 5.0348 8.349 5.57192L13.4059 10.6288L13.9361 10.0986L10.2446 6.4071C9.70839 5.87093 9.7085 5.0016 10.2448 4.46556Z"}}]};

const WaveLeftFilled = Vue.extend<IconProps>({
  name: 'WaveLeftFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wave-left-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WaveLeftFilled;
